export const DEFAULT_REQUEST_BODY = {
    pageNumber: 0,
    pageSize: 10,
    sortfield: 'createdAt',
    sortDirection: 'desc'
}